import { Box, Typography, Grid, TextField } from '@mui/material';
import { IDam } from '../../../services/api/dams/DamServices';

interface GeographicLocationProps  {
    data: IDam;
}

export const GeographicLocation = ({data}: GeographicLocationProps) => {

    return(
        <Box padding={0}>
            <Box>
                <Typography variant='h5'>Localização Geográfica</Typography>
            </Box>
            <Box padding={1} marginTop={0}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.descricao_acesso}
                            label='Descrição do acesso'
                            fullWidth
                        />
                    </Grid>
                    {/* <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.}
                            label='Datum Horizontal'
                            fullWidth
                        />
                    </Grid> */}
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.utm_zone_location}
                            label='Fuso/Zona'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.utm_ew}
                            label='Coordenadas UTM mE'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.utm_ns}
                            label='Coordenadas UTM mN'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.latitude}
                            label='Latitude (graus decimais)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.longitude}
                            label='Longitude (graus decimais)'
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};